var $ = jQuery.noConflict();

$(window).on('load', function () {
    let shortmin = 3;
    let li_count = $('.c-pagination__list li').length - 1;

    if (li_count >= shortmin) {
        $('.c-pagination__list li').addClass('off');

        $('.c-pagination__list li').eq(0).removeClass('off'); //remove from first
        $('.c-pagination__list li').eq(1).removeClass('off'); //remove from first
        $('.c-pagination__list li').eq(li_count).removeClass('off'); //remove from last

        $('.c-pagination__list li .active').closest('li').removeClass('off');
        $('.c-pagination__list li .active').closest('li').prev('li').removeClass('off');
        $('.c-pagination__list li .active').closest('li').next('li').removeClass('off');
        $('.c-pagination__list li .active').closest('li').next('li').next('li').removeClass('off');

        if ($('.c-pagination__list li .c-pagination__link').eq(0).hasClass('active')) {
            $('.c-pagination__list li').eq(2).removeClass('off');
            $('.c-pagination__list li').eq(3).removeClass('off');
        }
        if ($('.c-pagination__list li').eq(1).next('li').hasClass('off')) {
            $('.c-pagination__list li').eq(1).after('<li class="fz-pagination__sep">...</li>')
        }
        if ($('.c-pagination__list li').eq(li_count - 1).prev('li').hasClass('off')) {
            $('.c-pagination__list li').eq(li_count - 1).before('<li class="fz-pagination__sep">...</li>')
        }
    } else {
        $('.c-pagination__list li').removeClass('off');
    }
});
